// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-b5a357e8] {\n  min-height: calc(var(--vh) * 100);\n  background-color: #e8e8e8;\n}\n.page-box .add-btn[data-v-b5a357e8] {\n  width: 8.8rem;\n  height: 1.14667rem;\n  background: #f87a1b;\n  border-radius: 0.4rem;\n  font-size: 0.4rem;\n  font-weight: bold;\n  color: #fff4e4;\n  border: none;\n}\n.page-box .fixed[data-v-b5a357e8] {\n  position: fixed;\n  bottom: 0.8rem;\n  left: 50%;\n  margin-left: -4.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
